module.exports = __webpack_public_path__ + "img/approval.d59ecdbe.svg";